declare namespace $ {

	type $mol_text__text_bog_pazzle_board_victory_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_pazzle_board_victory_2 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['stats'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_pazzle_board_victory_3 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['best'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_bog_pazzle_board_victory_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_pazzle_board_victory_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['again'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_bog_pazzle_board_victory_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_pazzle_board_victory_7 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['home'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_pazzle_board_victory_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_pazzle_board_victory_9 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['saves'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_bog_pazzle_board_victory_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_list__rows_bog_pazzle_board_victory_11 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_victory['card_content'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_pazzle_board_victory extends $mol_view {
		Title( ): $mol_text
		stats( ): string
		Stats( ): $mol_text
		Best( ): $mol_text
		Again( ): $mol_button_major
		Home( ): $mol_button_minor
		Saves( ): $mol_button_minor
		Actions( ): $mol_row
		card_content( ): readonly(any)[]
		Card( ): $mol_list
		moves( ): number
		time( ): string
		best( ): string
		again( next?: any ): any
		home( next?: any ): any
		saves( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=victory.view.tree.d.ts.map